import React from "react";
import SubHeader from "../general/SubHeader";
import Abhishek from "../../assets/member/AbhishekRai.jpeg";

const AbhishekRai = () => {
  return (
    <>
      <SubHeader message="Members" />

      <section className="my-5">
        <div className="container text-center">
          <div className="sec-subheading">
            <hr />
            <span>Members</span>
            <hr />
          </div>
          <p className="sec-heading">Our Management Group</p>

          <div className="member-area row mt-5">
            <div className="col-lg-4 col-12 my-3 pe-lg-0">
              <img
                src={Abhishek}
                className="img-fluid border-0 rounded"
                alt="Agents"
              />
            </div>

            <div className="col-lg-8 col-12 my-3 text-muted">
              <div className="member-info">
                <p className="fw-bold fs-5 my-0 text-dark">Abhishek Rai</p>
                <span>Transportation Head</span>
                <br />
                <p className="mt-3 para-text fw-bold">
                  Education: Graduate
                  <br />
                  Experience: 1 year Working experience in Atul Auto mobile
                  <br />
                  3 year working experience in FORCE Moters
                  <br />6 years experience in Real Estate
                </p>

                <p>
                  "Swalok Group ke liye karya karna mere liye Garv ki baat hai
                  is group ke sath me main apna aur sabhi sathiyon ka bhavishya
                  Ujjwal hota hua dekh pa raha hu. Ham sabhi ke athak prayason
                  se yah sangathan Aakash ki nai unchaiyon ki or agrasar Ho"
                  <br />
                  <br />
                  <strong>
                    Abhishek Rai is the Transportation Head at Swalok Group,
                    where he oversees the smooth operation of transportation
                    logistics. With a strong background in the automotive and
                    real estate sectors, Abhishek brings a diverse set of skills
                    to the role.
                  </strong>
                  <br />
                  <br />
                  Abhishek’s career includes one year of experience at Atul Auto
                  Mobile, where he gained valuable insight into vehicle
                  management and operations. He further developed his expertise
                  with three years at FORCE Motors, where he contributed to
                  transportation solutions, optimizing fleet performance and
                  maintenance. Additionally, Abhishek has six years of
                  experience in the real estate sector, which has enhanced his
                  ability to manage logistics and transportation for large-scale
                  projects. His multi-industry experience enables Abhishek to
                  handle the transportation needs of Swalok Group efficiently,
                  ensuring timely deliveries and streamlined logistics.
                </p>
              </div>
            </div>
          </div>
          {/* row ends */}
        </div>
      </section>
    </>
  );
};

export default AbhishekRai;
